import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ComboTipoReuniao } from '../../../core/combo-tipos-reuniao';
import { TiposReuniaoService } from '../../../services/tipos-reuniao/tipo-reuniao.service';
@Component({
  selector: 'combo-tipo-reuniao',
  templateUrl: './combo-tipo-reuniao.component.html',
  styleUrls: ['./combo-tipo-reuniao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboTipoReuniaoComponent implements OnInit {

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() label;
  @Input() campoPesquisavel = 'descricao';
  @Input() fxFlexOffset = "20px";

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};
  
  constructor(private tiposReuniaoService: TiposReuniaoService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    setTimeout(() => {
      let $_evento;
      
      $_evento = this.tiposReuniaoService.getAllCombo();  

      $_evento.subscribe((comboTiposReuniaoComponent: ComboTipoReuniao[]) => {
        this.dados = comboTiposReuniaoComponent;
        this.preencherCombo();

        this.dados.forEach(a => {
          a.descricao = a.descricao;
        } );

        
        this.dados.sort((a, b) => {
          if (a.descricao > b.descricao) { return 1; }
          return 0;
        });
      });

    }, 0);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
      this.preencherCombo();
    }
  }

  private preencherCombo() {
    if (this.selecionado && this.selecionado.descricao) {
      const existe = this.dados.some(item => 
        item.id === this.selecionado.id && item.descricao === this.selecionado.descricao
      );
      if (!existe) {
        this.dados.push(this.selecionado);
      }
    }
    if (this.selecionado && this.selecionado.id && this.dados.length) {
      this.selecionado = _.find(this.dados, { id: this.selecionado.id });
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }
}
